export const readFile = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = ({ target }) => {
      const result = target?.result;
      if (result && typeof result === 'string') {
        resolve(result);
      } else {
        reject(new Error('File reading error: result is not a string'));
      }
    };
    fileReader.readAsText(file);
  });
